import clarity from '@microsoft/clarity';

// Initialize Clarity with your project ID
export function initClarity() {
  // Replace this with your actual Clarity project ID
  clarity.init("qy1uz2k0m6");

  console.log('Microsoft Clarity initialized');
}
